/**
 * @generated SignedSource<<3e294be09102fc260f12391f928f5379>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedRespLinksBlock_item$data = {
  readonly popularSearchesLink: {
    readonly " $fragmentSpreads": FragmentRefs<"SharedPopularSearchesLink_popularSearchesLink">;
  };
  readonly sitemapLinks: ReadonlyArray<{
    readonly __typename: "LinkData";
  }> | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSitemapLinks_item">;
  readonly " $fragmentType": "SharedRespLinksBlock_item";
};
export type SharedRespLinksBlock_item$key = {
  readonly " $data"?: SharedRespLinksBlock_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRespLinksBlock_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRespLinksBlock_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "popularSearchesLink",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedPopularSearchesLink_popularSearchesLink"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "sitemapLinks",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSitemapLinks_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "9cfd4571895d8ca2ea48b9fb8e7e5c23";

export default node;
